import React from "react";

const PrivacyPage = () => {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="legal-muted">
        This template describes, at a high level, how CrunchAlpha may process
        personal data. The final policy will be aligned with applicable privacy
        regulations and internal compliance.
      </p>

      <section>
        <h2>1. Data We Collect</h2>
        <ul>
          <li>Basic identity data: name, email address, country.</li>
          <li>
            Trading account information (account IDs, broker, performance
            statistics).
          </li>
          <li>
            Activity logs: logins, profile changes, strategy configuration, and
            other usage events.
          </li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Data</h2>
        <ul>
          <li>
            To provide AlphaRank scoring, performance analytics, and risk
            metrics.
          </li>
          <li>To display Trader and Analyst profiles to Investors.</li>
          <li>To improve the product and detect fraud or abuse.</li>
        </ul>
      </section>

      <section>
        <h2>3. Data Sharing</h2>
        <p>
          CrunchAlpha does not sell personal data to third parties. Data may be
          shared with relevant partners (such as connected brokers or payment
          providers) only to the extent necessary to deliver the service.
        </p>
      </section>

      <section>
        <h2>4. Data Security</h2>
        <p>
          We use industry-standard safeguards such as encryption in transit,
          access controls, and activity logs. However, no system can guarantee
          absolute security.
        </p>
      </section>

      <section>
        <h2>5. Data Retention</h2>
        <p>
          We retain data for as long as your account remains active and for a
          reasonable period thereafter, subject to regulatory and audit
          requirements.
        </p>
      </section>

      <section>
        <h2>6. Your Rights</h2>
        <ul>
          <li>The right to access and correct your personal data.</li>
          <li>
            The right to request deletion of certain data, subject to legal and
            regulatory constraints.
          </li>
          <li>
            The right to opt out of non-essential communications such as
            marketing emails.
          </li>
        </ul>
      </section>
    </div>
  );
};

export default PrivacyPage;
